import { render, staticRenderFns } from "./helpGetCoupon.vue?vue&type=template&id=4881ff7e&scoped=true&"
import script from "./helpGetCoupon.vue?vue&type=script&lang=ts&"
export * from "./helpGetCoupon.vue?vue&type=script&lang=ts&"
import style0 from "./helpGetCoupon.vue?vue&type=style&index=0&id=4881ff7e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881ff7e",
  null
  
)

export default component.exports